var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-body"},_vm._l((_vm.pool.tokens),function(token){return _c('ListToken',{key:token.address,class:'table-tr',attrs:{"pool":_vm.pool,"bPool":_vm.bPool,"token":token}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }